<app-page-wrapper>
  <div class="account-type-wrapper">
    <app-heavy-header title="How do you want to verify?" description="If you have an invite code, you can enter it here and verify your identity. Otherwise, select your jet membership provider to verify that membership."></app-heavy-header>
    <div class="account-type-btns">
      <app-primary-btn gradient="true" mb="12px" (click)="onSelect('invited')">
        I Have an Invite Code
      </app-primary-btn>
      <app-primary-btn gradient="true" (click)="onSelect('member')">
        Verify Membership (NetJets, FlexJet, etc)
      </app-primary-btn>
    </div>
  </div>
</app-page-wrapper>
